import React from 'react';
import { OrganizationExecutiveStatsItem } from './components';
import { daoTreasuryInvestmentsPageIcon } from 'assets';
import styles from './styles.module.scss';

const organizationName = 'Sample DAO';

const mockExecutiveStats = {
    tokenPrice: {
        orgRankInPercentage: 75,
        priceGain: 24.5,
        updatedAt: new Date().toISOString(),
        orgRank: 45
    },
    treasuryDiversification: {
        orgRankInPercentage: 68,
        diversificationPercentage: 42.3,
        orgRank: 32
    },
    tokenReliance: {
        orgRankInPercentage: 83,
        tokenReliancePercentage: 15.7,
        orgRank: 17
    },
};

export const financeTooltipText = (
    <span>
        <b>Token Price Gain</b>: Measures the gain in token price over the past 3 months (starting from the latest
        update date on DeepDAO) and how it compares to other DAOs in the ecosystem.
        <br />
        <br />
        <b>Treasury Diversity</b>: Looks at the composition of the DAO&apos;s treasury. What percentage of it consists
        of tokens tokens tokens tokens other than the DAO&apos;s voting token (which is typically the main project
        token)? Are other DAOs diversified? (More information about this can be found in the Token tab.)
        <br />
        <br />
        <b>Token Reliance on Treasury</b>: Examines the number of DAO tokens in the treasury compared to the
        token&apos;s circulating supply. This ratio is important for understanding the DAO&apos;s token strategy and
        management approach.
        <br />
        <br />
        <b>Important note</b>: These metrics and data are not financial advice. Please do your own research.
    </span>
);

export const governanceTooltipText = (
    <span>
        <b>Active Delegates</b>: How active are the DAO&apos;s delegates? How many of them voted at least once in
        months? This calculating looks at delegates who have more then themselves at a delegator.
        <br />
        <br />
        <b>Dominant Coalition</b>:A coalition is defined as a group of voters and delegates who frequently vote together
        over the past 3 months. How much power do they hold together? Are other DAos in the ecosystem dominated more, or
        less by strong coalitions? See also our Coalitions tab for a detailed breakdown of the DAO&apos;s coalition
        groups. coalition is defined as a group of voters and delegates who frequently vote together over the past 3
        months. How much power do they hold together? Are other DAos in the ecosystem dominated more, or less by strong
        coalitions? See also our Coalitions tab for a detailed breakdown of the DAO&apos;s coalition groups.
        <br />
        <br />
        <b>Loyal Voters</b>: We define a loyal voter as a voter who voted in each of the past 3 years (starting from now
        and going back 12, 24, and 36 months). This metric compares the number of loyal voters over the number of the
        DAO&apos;s governance token holders, and compares this DAO to others in the ecosystem.
        <br />
        <br />
        <b>Missing Voters</b>: We define a missing voter as a voter who voted at least once in the past, but not this
        year (from now and back 12 months). This metric compares the number of missing voters over the number of the
        DAO&apos;s governance token holders, and compares this DAO to others in the ecosystem.
        <br />
        <br />
        <b>Note</b>: a CSV with a full list of the missing, and loyal voters is available for subscribing DAOs.
    </span>
);

export const blurredContent = (
    <>
        <div className={styles.sectionTitle}>
            <h4>Financial</h4>
        </div>
        <div className={styles.gridContainer}>
            <OrganizationExecutiveStatsItem
                hasProgressBar={false}
                hasProgressBarPercentage={true}
                title="Token Price Gain"
                icon={daoTreasuryInvestmentsPageIcon}
                organizationName={organizationName}
                circularPercentage={mockExecutiveStats.tokenPrice.orgRankInPercentage}
                progressBarTitle={"deepDAO's Latest"}
                progressBarBottomTitle={`${organizationName}'s token price gained`}
                progressBarPercentage={mockExecutiveStats.tokenPrice.priceGain}
                progressBarDescription={`over the past 3 months. Last update on DeepDAO at ${new Date(
                    mockExecutiveStats.tokenPrice.updatedAt,
                )
                    .toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                    })
                    .replace(/\//g, '/')}`}
                description={`${organizationName}'s token price gained more than ${
                    mockExecutiveStats.tokenPrice.orgRank - 1
                } DAOs (${mockExecutiveStats.tokenPrice.orgRankInPercentage}%) over the past 3 months.`}
            />
            <OrganizationExecutiveStatsItem
                title="Treasury diversification"
                icon={daoTreasuryInvestmentsPageIcon}
                organizationName={organizationName}
                circularPercentage={mockExecutiveStats.treasuryDiversification.orgRankInPercentage}
                progressBarTitle={'current treasury'}
                progressBarBottomTitle={`${organizationName} has`}
                progressBarPercentage={mockExecutiveStats.treasuryDiversification.diversificationPercentage}
                progressBarDescription={'of its treasury in tokens other than its own'}
                description={`${organizationName} has diversified its treasury more than ${
                    mockExecutiveStats.treasuryDiversification.orgRank - 1
                } DAOs (${mockExecutiveStats.treasuryDiversification.orgRankInPercentage}%).`}
            />
            <OrganizationExecutiveStatsItem
                title="Token Reliance on Treasury"
                icon={daoTreasuryInvestmentsPageIcon}
                organizationName={organizationName}
                circularPercentage={mockExecutiveStats.tokenReliance.orgRankInPercentage}
                progressBarTitle={'current reliance'}
                progressBarBottomTitle={`${organizationName} has`}
                progressBarPercentage={mockExecutiveStats.tokenReliance.tokenReliancePercentage}
                progressBarDescription={'of its token circulating supply in its treasury'}
                description={`This ${organizationName} token has a higher percentage in its treasury, vs. its circulating supply, than ${
                    mockExecutiveStats.tokenReliance.orgRank - 1
                } DAOs (${mockExecutiveStats.tokenReliance.orgRankInPercentage}%).`}
            />
        </div>
    </>
);